// extracted by mini-css-extract-plugin
export default {"fields":"pjWJE5","fields__row":"pMYF0K","fields__item":"NcAnee","fields__delim":"hP3OmK","swap":"NMSKmX","singleField":"stEXGG","placeDisplay":"TcR3OK"};